// extracted by mini-css-extract-plugin
export var root = "PageTitle-module--root--9s1t2";
export var pageTitle = "PageTitle-module--pageTitle--oXGwS";
export var subtitle = "PageTitle-module--subtitle--Zj3VC";